<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>


export default {
    name: 'app',
    components: {
    }
}
</script>

<style>
#app {
    font-family: 'Kanit', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #503B2D;
}

/* ALIGN */
.centerv{
    align-self: center;
}

.bottomv{    
    align-self: end;
}

.navbar-toggler{
    border: none !important;
}

.navbar-toggler:focus{
    box-shadow: none !important;
}

#privacy-wrapper p{
    margin-bottom: 0px !important;
    font-weight: 300;
}

#privacy-wrapper a{
    text-decoration: none !important;
    color: #503B2D !important;
}
</style>
